import { CardStatus } from '@seapoint/server/enums';
import { MoreHorizontal, Snowflake, SquarePen, Trash2 } from 'lucide-react';
import { useState } from 'react';
import { Button } from '../../../design-system/button/button';
import { Inline } from '../../../design-system/inline/inline';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../../../design-system/ui/dropdown-menu';

type CardActionsMenuProps = {
  cardStatus: CardStatus;
  onFreezeCard?: () => void;
  onCancelCard?: () => void;
  onEditNickname: () => void;
};

export const CardActionsMenu = ({ cardStatus, onFreezeCard, onCancelCard, onEditNickname }: CardActionsMenuProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isActive = cardStatus === CardStatus.ACTIVE;
  const isCancelled = cardStatus === CardStatus.CANCELLED;
  const showFreeze = !!onFreezeCard;
  const showCancel = !!onCancelCard;

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="secondary"
          size="icon"
          className="size-9 rounded-full"
          aria-label="Card actions"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setIsOpen((prev) => !prev);
          }}
        >
          <MoreHorizontal size={16} />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="z-[9999] w-[200px]">
        <DropdownMenuGroup>
          {showFreeze && (
            <DropdownMenuItem onSelect={onFreezeCard} disabled={!isActive}>
              <Inline space={2} align="center">
                <Snowflake className="h-4 w-4 text-muted-foreground" />

                <span className="text-sm">Freeze card</span>
              </Inline>
            </DropdownMenuItem>
          )}

          {showCancel && (
            <DropdownMenuItem onSelect={onCancelCard} disabled={isCancelled}>
              <Inline space={2} align="center">
                <Trash2 className="h-4 w-4 text-muted-foreground" />

                <span className="text-sm">Cancel card</span>
              </Inline>
            </DropdownMenuItem>
          )}
        </DropdownMenuGroup>

        {(showFreeze || showCancel) && <DropdownMenuSeparator />}

        <DropdownMenuGroup>
          <DropdownMenuItem onSelect={onEditNickname}>
            <Inline space={2} align="center">
              <SquarePen className="h-4 w-4 text-muted-foreground" />

              <span className="text-sm">Edit card nickname…</span>
            </Inline>
          </DropdownMenuItem>
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
